module.exports = __webpack_public_path__ + "img/lab.4ad8a578.jpg";